var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBathroom = function SvgBathroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bathroom_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.354 22.413 19.94 24l.994-.994-1.587-1.587zM3.065 23.006 4.06 24l1.587-1.587-.995-.994z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bathroom_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bathroom_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.86 12.188H1.452V3.515A3.52 3.52 0 0 1 4.97 0h1.406a3.52 3.52 0 0 1 3.516 3.516H8.484c0-1.163-.946-2.11-2.109-2.11H4.969c-1.163 0-2.11.947-2.11 2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.188 2.813a3.52 3.52 0 0 0-3.516 3.515v.703h7.031v-.703a3.52 3.52 0 0 0-3.515-3.516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M22.547 13.36v4.453a4.927 4.927 0 0 1-4.922 4.921H6.375a4.927 4.927 0 0 1-4.922-4.922V13.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M22.547 13.36v4.453a4.927 4.927 0 0 1-4.922 4.921H12V13.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.703 14.297v-2.813h3.89a1.408 1.408 0 0 1 0 2.813zM13.547 11.484v2.813H1.407A1.41 1.41 0 0 1 0 12.89c0-.776.63-1.407 1.406-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.547 14.297H12v-2.813h1.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M17.625 10.078h-2.812c-1.164 0-2.11.947-2.11 2.11v4.921h7.031v-4.922c0-1.162-.946-2.109-2.109-2.109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M19.734 12.188v4.921h-3.562v-7.03h1.453c1.163 0 2.11.945 2.11 2.108"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bathroom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBathroom;